/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  APIKeyPolicySelector,
  APIKeyPolicySelector$inboundSchema,
  APIKeyPolicySelector$Outbound,
  APIKeyPolicySelector$outboundSchema,
} from "./apikeypolicyselector.js";

/**
 * mcp:connect, mcp:auth, or a block: mcp:blocked_connect, mcp:blocked_auth
 */
export const APIKeyPolicyGrantScope = {
  McpConnect: "mcp:connect",
  McpBlockedConnect: "mcp:blocked_connect",
  McpAuth: "mcp:auth",
  McpBlockedAuth: "mcp:blocked_auth",
} as const;
/**
 * mcp:connect, mcp:auth, or a block: mcp:blocked_connect, mcp:blocked_auth
 */
export type APIKeyPolicyGrantScope = OpenEnum<typeof APIKeyPolicyGrantScope>;

export type APIKeyPolicyGrant = {
  /**
   * mcp:connect, mcp:auth, or a block: mcp:blocked_connect, mcp:blocked_auth
   */
  scope: APIKeyPolicyGrantScope;
  /**
   * What an API key policy grant covers: servers (mcp) or auth clients (mcp_auth_client).
   */
  selector: APIKeyPolicySelector;
};

/** @internal */
export const APIKeyPolicyGrantScope$inboundSchema: z.ZodMiniType<
  APIKeyPolicyGrantScope,
  unknown
> = openEnums.inboundSchema(APIKeyPolicyGrantScope);
/** @internal */
export const APIKeyPolicyGrantScope$outboundSchema: z.ZodMiniType<
  string,
  APIKeyPolicyGrantScope
> = openEnums.outboundSchema(APIKeyPolicyGrantScope);

/** @internal */
export const APIKeyPolicyGrant$inboundSchema: z.ZodMiniType<
  APIKeyPolicyGrant,
  unknown
> = z.object({
  scope: APIKeyPolicyGrantScope$inboundSchema,
  selector: APIKeyPolicySelector$inboundSchema,
});
/** @internal */
export type APIKeyPolicyGrant$Outbound = {
  scope: string;
  selector: APIKeyPolicySelector$Outbound;
};

/** @internal */
export const APIKeyPolicyGrant$outboundSchema: z.ZodMiniType<
  APIKeyPolicyGrant$Outbound,
  APIKeyPolicyGrant
> = z.object({
  scope: APIKeyPolicyGrantScope$outboundSchema,
  selector: APIKeyPolicySelector$outboundSchema,
});

export function apiKeyPolicyGrantToJSON(
  apiKeyPolicyGrant: APIKeyPolicyGrant,
): string {
  return JSON.stringify(
    APIKeyPolicyGrant$outboundSchema.parse(apiKeyPolicyGrant),
  );
}
export function apiKeyPolicyGrantFromJSON(
  jsonString: string,
): SafeParseResult<APIKeyPolicyGrant, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => APIKeyPolicyGrant$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'APIKeyPolicyGrant' from JSON`,
  );
}
